var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6666 1.33337V4.00004",
    stroke: "currentColor",
    strokeWidth: 1.03323,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 1.33337V4.00004",
    stroke: "currentColor",
    strokeWidth: 1.03323,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6.00008H14",
    stroke: "currentColor",
    strokeWidth: 1.03323,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6667 2.66663H3.33333C2.59667 2.66663 2 3.26329 2 3.99996V12.6666C2 13.4033 2.59667 14 3.33333 14H12.6667C13.4033 14 14 13.4033 14 12.6666V3.99996C14 3.26329 13.4033 2.66663 12.6667 2.66663Z",
    stroke: "currentColor",
    strokeWidth: 1.03323,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6752 8.486C4.5832 8.486 4.50853 8.56067 4.5092 8.65267C4.5092 8.74467 4.58386 8.81934 4.67586 8.81934C4.76786 8.81934 4.84253 8.74467 4.84253 8.65267C4.84253 8.56067 4.76786 8.486 4.6752 8.486",
    stroke: "currentColor",
    strokeWidth: 1.03323,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00869 8.486C7.91669 8.486 7.84203 8.56067 7.84269 8.65267C7.84269 8.74467 7.91736 8.81934 8.00936 8.81934C8.10136 8.81934 8.17603 8.74467 8.17603 8.65267C8.17603 8.56067 8.10136 8.486 8.00869 8.486",
    stroke: "currentColor",
    strokeWidth: 1.03323,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3419 8.486C11.2499 8.486 11.1753 8.56067 11.1759 8.65267C11.1759 8.74467 11.2506 8.81934 11.3426 8.81934C11.4346 8.81934 11.5093 8.74467 11.5093 8.65267C11.5093 8.56067 11.4346 8.486 11.3419 8.486",
    stroke: "currentColor",
    strokeWidth: 1.03323,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6752 11.1528C4.5832 11.1528 4.50853 11.2274 4.5092 11.3194C4.5092 11.4114 4.58386 11.4861 4.67586 11.4861C4.76786 11.4861 4.84253 11.4114 4.84253 11.3194C4.84253 11.2274 4.76786 11.1528 4.6752 11.1528",
    stroke: "currentColor",
    strokeWidth: 1.03323,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00869 11.1528C7.91669 11.1528 7.84203 11.2274 7.84269 11.3194C7.84269 11.4114 7.91736 11.4861 8.00936 11.4861C8.10136 11.4861 8.17603 11.4114 8.17603 11.3194C8.17603 11.2274 8.10136 11.1528 8.00869 11.1528",
    stroke: "currentColor",
    strokeWidth: 1.03323,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.c8100abf7efcf4f3f63f4dfb285b14a7.svg";
export { ForwardRef as ReactComponent };